export default {
  en: {
    contract: 'Contract'
  },
  th: {
    contract: 'สัญญา'
  }
}
